import EmptyView from "components/EmptyView";
import Text from "components/Text";
import { greybackground } from "data/commonClasses";
import { getTranslationContent } from "functions";
import { isEmpty } from "lodash";
import React from "react";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

const ImageWithText = ({ data, lang, withMinHeight }) => {

  let image = data?.image;
  let imageLeft = data?.imageLeft;
  const applyImageLeft =
    (lang == "ar" && imageLeft) || (lang !== "ar" && !imageLeft);
  const { t } = useTranslation();

  const renderImage = () => {
    return (
      <img
        src={image && image !== "" ? image : "/placeholder.jpg"}
        className={"w-full lg:w-[550px] object-cover rounded-button"}
      />
    );
  };
  const renderText = () => {
    return (
      <div className={twMerge(greybackground, "my-0 px-5 lg:px-14 w-full")}>
        <Text
          text={getTranslationContent(data, "title", lang)}
          className="pb-7"
          sectionTitle
          bold
        />
        <div
          className="text-black"
          dangerouslySetInnerHTML={{ __html: getTranslationContent(data, "content", lang) }}
        />
      </div>
    );
  };

  return data && !isEmpty(data) ? (
    <div
      className={twMerge(
        "flex flex-col lg:flex-row justify-center gap-6 xk:my-6 my-3",
        withMinHeight ? "min-h-screen" : ""
      )}
    >
      {applyImageLeft ? (
        <>
          {renderText()}
          {renderImage()}
        </>
      ) : (
        <>
          {renderImage()}
          {renderText()}
        </>
      )}
    </div>
  ) : (
    <EmptyView
      withWrapper
      text={t("noInfo")}
      icon={"fluent-mdl2:remove-content"}
    />
  );
};

export default ImageWithText;
